export class ScreenButton extends Sprite {
  constructor(settings) {
    super();
    this._createButton(settings)
  }

  isMouseInIButton() {
    if(!this.visible) return false;

    if ((this._button !== null) && this._button.visible) {
      return this._button.cursorInButton();
    } else {
      return false;
    }
  }

  isTouching() {
    if(!this.visible) return false;

    if ((this._button !== null) && this._button.visible) {
      return this._button.touchInButton() && this._button.isActive();
    } else {
      return false;
    }
  }

  isHolding() {
    if(!this.visible) return false;

    if ((this._button !== null) && this._button.visible) {
      return this._button.touchInButton() && this._button.isActive() && TouchInput.isRepeated();
    } else {
      return false;
    }
  }

  addClickHadler(cb) {
    this._button.addClickHandler(cb);
  }

  move(x, y) {
    this._button.move(new KDCore.Point(x, y));
  }

  disable() {
    this._button.applyDisableState();
  }

  show() {
    this._button.show();
  }

  hide() {
    this._button.hide();
  }

  _createButton(settings) {
    let img0, img1, img2, img3;
    this._button = new KDCore.Button();

    this._button.move(KDCore.Utils.jsonPos(settings.position));
    img0 = ImageManager.loadBitmap('img/buttons/', settings.mainImg, 0, true);
    img1 = ImageManager.loadBitmap('img/buttons/', settings.hoverImg, 0, true);
    img2 = ImageManager.loadBitmap('img/buttons/', settings.pressedImg, 0, true);
    img3 = ImageManager.loadBitmap('img/buttons/', settings.disabledImg, 0, true);

    this._button.setButtonImages(img0, img1, img2, img3);
    this._button.setAlphaMode();

    if (settings.labelText !== null) {
      this._setLabelText(settings.labelText)
    }

    this._button.visible = settings.visible;

    this.addChild(this._button);
  }

  _setLabelText(labelText) {
    this._button.setHelpText(labelText[0], labelText[1]);
    this._button.setTextPosition(labelText[2]);
  }
}

DataManager._databaseFiles.push({
  name: '$YS_ButtonSettings',
  src: 'YS_ButtonSettings.json'
});
